import React from 'react';
import { LightIconSvg } from '../../icons';
import { AccessoryCard } from '../../common/cards/AccessoryCard';
import { useModalHelper } from '../../common/hooks';
import { LightCardModal } from './LightCardModal';
export var LightCard = function (_a) {
    var _b = _a.capabilities, capabilities = _b === void 0 ? {
        SUPPORT_BRIGHTNESS: false,
        SUPPORT_COLOR: false,
    } : _b, brightness = _a.brightness, iconActive = _a.iconActive, iconInactive = _a.iconInactive, name = _a.name, on = _a.on, onToggle = _a.onToggle, onBrightnessChange = _a.onBrightnessChange;
    var _c = useModalHelper(), showModal = _c.showModal, openModal = _c.openModal, closeModal = _c.closeModal;
    var stateLabel = on ?
        brightness ? "".concat(brightness, "%") : 'On' :
        'Off';
    return (React.createElement(React.Fragment, null,
        React.createElement(AccessoryCard, { iconActive: iconActive ? iconActive : React.createElement(LightIconSvg, null), iconInactive: iconInactive ? iconInactive : React.createElement(LightIconSvg, null), name: name, state: stateLabel, isActive: on, handlePress: onToggle, handleLongPress: openModal }),
        React.createElement(LightCardModal, { name: name, state: stateLabel, capabilities: capabilities, on: on, onToggle: onToggle, brightness: brightness, onBrightnessChange: onBrightnessChange, show: showModal, close: closeModal })));
};
//# sourceMappingURL=LightCard.js.map